var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import ReactDOM from 'react-dom';
import { tomorrow, isDaySame, isToday } from '../app/date-helpers';
import { canBookTodayForHour } from '../app/time-helpers';
import { enablePopover, smoothScroll } from '../app/ui';
import { DEFAULT_VALUES, MAX_GROUP } from '../config';
import { checkAndLogPWAUsage, reloadIfVisitedLongAgo } from '../pwa';
import HomePageOrderSelectBar from 'Comps/Home/HomePageOrderSelectBar';
import HomeSelectCuisine from 'Comps/Home/HomeSelectCuisine';
import { TOO_BIG_GROUP } from 'App/app/lang';
import SelectBar from 'Comps/SelectBar';
import OtoAlert from 'Comps/common/OtoAlert';
import { createDerivedStateFromErrorLogger } from '../utils/log';
import { isLUBJE } from 'App/services/tenant';
import './home-switch.scss';
import { getHoursRange } from 'Utils/reservation';
var TABS = {
    ORDER: 'eat-at-home',
    BOOK: 'restaurant',
};
var defaultReservationHours = getHoursRange(32400, 75600);
var COMPONENT_NAME = 'HomeSelectBar';
var HomeSelectBar = /** @class */ (function (_super) {
    __extends(HomeSelectBar, _super);
    function HomeSelectBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.staticdisplayName = COMPONENT_NAME;
        _this.staticgetDerivedStateFromError = createDerivedStateFromErrorLogger(COMPONENT_NAME);
        _this.state = {
            allHours: defaultReservationHours,
            hours: defaultReservationHours,
            peopleAmount: DEFAULT_VALUES.peopleAmount,
            selectBarVisitTime: DEFAULT_VALUES.visitTime,
            visitTime: DEFAULT_VALUES.visitTime,
            visitDate: tomorrow,
            showTooBigGroupAlert: false,
        };
        _this.handleDateChange = function (date) {
            var isSameDaySelected = isDaySame(_this.state.visitDate, date);
            _this.setState({ visitDate: date });
            if (isSameDaySelected) {
                return;
            }
            if (isToday(date)) {
                var newValidHours = _this.state.allHours.filter(canBookTodayForHour);
                newValidHours.length &&
                    _this.handleTimeChange({ target: { value: newValidHours[0] } });
                _this.setState({ hours: newValidHours });
            }
            else {
                _this.setState({ hours: _this.state.allHours });
            }
        };
        _this.handleTimeChange = function (event) {
            var visitTime = event.target.value;
            _this.setState({
                visitTime: visitTime,
                selectBarVisitTime: visitTime,
            });
        };
        _this.handlePeopleAmountChange = function (event) {
            var value = parseInt(event.target.value, 10);
            var isTooBig = value > MAX_GROUP;
            var newState = __assign(__assign({}, _this.state), { peopleAmount: isTooBig ? MAX_GROUP : value, showTooBigGroupAlert: isTooBig });
            _this.setState(newState);
        };
        return _this;
    }
    HomeSelectBar.prototype.componentDidMount = function () {
        enablePopover();
        smoothScroll();
        checkAndLogPWAUsage('homepage');
        reloadIfVisitedLongAgo();
        var placeholder = document.querySelector('#react-placeholder');
        placeholder && placeholder.remove();
    };
    HomeSelectBar.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("nav", { className: "home-switch ".concat(isLUBJE() ? 'home-switch--lubje' : '') },
                isLUBJE() && (React.createElement("h3", { className: "lubje-subtitle mb-3" }, "Rozpocznij swoje zam\u00F3wienie")),
                React.createElement("div", { className: "home-switch__content" }, isLUBJE() ? (React.createElement(HomePageOrderSelectBar, null)) : (this.renderReservationTab())))));
    };
    HomeSelectBar.prototype.renderReservationTab = function () {
        var _a = this.state, visitDate = _a.visitDate, selectBarVisitTime = _a.selectBarVisitTime, peopleAmount = _a.peopleAmount, showTooBigGroupAlert = _a.showTooBigGroupAlert;
        return (React.createElement(React.Fragment, null,
            React.createElement(SelectBar, { hasButton: true, isInline: true, className: "select-bar--inline", formClassName: "select-bar-form", handleDateChange: this.handleDateChange, handleTimeChange: this.handleTimeChange, handlePeopleAmountChange: this.handlePeopleAmountChange, visitDate: visitDate, visitTime: selectBarVisitTime, peopleAmount: peopleAmount, reservationHours: this.state.hours }),
            React.createElement("div", { className: "mt-3 empty-d-none" }, showTooBigGroupAlert && React.createElement(OtoAlert, { text: TOO_BIG_GROUP }))));
    };
    return HomeSelectBar;
}(React.PureComponent));
export default HomeSelectBar;
ReactDOM.render(React.createElement(HomeSelectBar, null), document.getElementById('hello-form'));
var selectCuisineContainer = document.getElementById('home-select-cuisine');
if (!!selectCuisineContainer) {
    ReactDOM.render(React.createElement(HomeSelectCuisine, null), selectCuisineContainer);
}
